import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { routePrefix } from "../../config";
import * as actions from "../../containers/inventoryView/actions";
import moment from "moment";
import refresh from "../../images/refresh.svg";
import downloadIcon from "../../images/download.svg";
import classNames from "classnames";

class InventorycalendarView extends React.Component {
  onRefreshClick = (e, date) => {
    e.preventDefault();
    this.props.inventoryAllRoutesRefresh({
      date: date,
    });
    setTimeout(function () {
      window.location.reload();
    }, 1000);
  };
  onDownloadClick = (e, date) => {
    const providerId = JSON.parse(localStorage.getItem('provider-id'));
    const operatorId = JSON.parse(localStorage.getItem('operator-id'));
    const paramsObj = [];
    paramsObj.pid = providerId;
    paramsObj.oid= operatorId;
    paramsObj.date = date;
    e.preventDefault();
    this.props.downloadCSV('daylevel', paramsObj);
  };

  onPageRedirection = (e, date) => {
    e.stopPropagation();
    localStorage.setItem("selected-date", date);
  };

  render() {
    const { date, index, isDisabled, calendarInfo, isShowDate } = this.props;
    let download_support = JSON.parse(localStorage.getItem('download-support'));
    return (
      <>
        {isDisabled && (
          <div className="disabledTile">
            {isShowDate ? (
              <span className="date">{moment(date).format("DD")}</span>
            ) : (
              ""
            )}
          </div>
        )}

        {!isDisabled &&
          (calendarInfo.services > 0 ||
            calendarInfo.rejected > 0 ||
            calendarInfo.is_refreshable === true) && (
            <Link
              to={routePrefix + "/inventory-view/daylevel"}
              onClick={(e) => {
                this.onPageRedirection(e, date);
              }}
            >
              <div className="activecalendarTile">
                <div className="tileTop">
                  <span className="date">
                    {date && moment(date).format("DD")}
                  </span>
                  <div className="action-buttons">
                    {calendarInfo.is_refreshable === true ? (
                      <div
                        className="refreshButtonDaylevel"
                        onClick={(e) => {
                          this.onRefreshClick(e, date);
                        }}
                      >
                        <img src={refresh} alt="refresh-icon" />
                      </div>
                    ) : (
                      <div className="refreshButtonDisabled">
                        <img src={refresh} alt="refresh-icon" />
                      </div>
                    )}
                    {download_support &&
                      <div
                        className="refreshButtonDaylevel"
                        onClick={(e) => {
                          this.onDownloadClick(e, date)
                        }}
                      >
                        <img src={downloadIcon} alt="refresh-icon" />
                      </div>
                    }
                  </div>
                </div>
                <div className="tileBottom">
                  <div className="serviesCount">
                    Services : {calendarInfo.services}{" "}
                  </div>
                  <div
                    className={classNames({
                      rejectedDisabled: calendarInfo.rejected === 0,
                    })}
                  >
                    Rejected :
                    <span
                      className={classNames("rejected", {
                        rejectedDisabled: calendarInfo.rejected === 0,
                      })}
                    >
                      {calendarInfo.rejected}
                    </span>
                  </div>
                  <span className="lastUpdatedStatus">
                    {calendarInfo.last_updated_end && (
                      <div>
                        Last Updated -{" "}
                        {moment(calendarInfo.last_updated_end).format(
                          "h:mm A, MMM Do"
                        )}
                      </div>
                    )}
                  </span>
                </div>
              </div>
            </Link>
          )}

        {!isDisabled &&
          calendarInfo.services === 0 &&
          calendarInfo.rejected === 0 &&
          calendarInfo.is_refreshable === false && (
            <Link
              to={routePrefix + "/inventory-view/daylevel"}
              onClick={(e) => {
                this.onPageRedirection(e, date);
              }}
            >
              <div className="activecalendarTile">
                <div className="tileTopNoData">
                  <span className="date">{moment(date).format("DD")}</span>
                </div>
                <div className="tileBottomNoData">
                  <div className="rejectedDisabled">Services : No Data</div>
                  <div className="rejectedDisabled">Rejected : No Data</div>
                </div>
              </div>
            </Link>
          )}
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  inventoryAllRoutesRefreshData:
    store.inventoryViewReducer.inventoryAllRoutesRefreshData,
});

const mapDispatchToProps = (dispatch) => ({
  inventoryAllRoutesRefresh: (date) =>
    dispatch(actions.inventoryAllRoutesRefresh(date)),
  downloadCSV : (source, paramsObj) => 
    dispatch(actions.downloadCSV(source, paramsObj)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventorycalendarView);
